import useInput from "hooks/useInput";
import { TextArea as IParqueTextArea } from "iparque-components";
import React, { InputHTMLAttributes } from "react";

interface Props extends InputHTMLAttributes<HTMLTextAreaElement> {
  name: string;
  label: string;
  rows?: number;
}

const TextArea: React.FC<Props> = ({ id, name, label, ...props }) => {
  const { field, hasError } = useInput(name);

  return (
    <IParqueTextArea label={label} error={hasError} {...field} {...props} />
  );
};

export default TextArea;
